export function isValidDate(dateStr) {
  // ___________형식이 정확히 YYYY-MM-DD인지 정규표현식으로 확인___________
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false;

  const date = new Date(dateStr);

  if (isNaN(date.getTime())) return false;

  const [year, month, day] = dateStr.split("-").map(Number);
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() + 1 === month &&
    date.getUTCDate() === day
  );
}
